export default "__VITE_ASSET__CICdxFob__"